import classNames from 'classnames';
import { Link } from 'gatsby';
import * as React from 'react';

function ListTitle({
  children,
  showAction = true,
  fontSize,
  linkTo,
  id,
  rightContent,
  scrollOffset = -5,
  scrollRef,
  className,
}) {
  return (
    <div
      className={classNames(
        'text-3xl relative list-title-wrapper flex justify-between items-center font-extrabold',
        className,
      )}
    >
      <div
        id={id}
        style={{ position: 'absolute', top: scrollOffset }}
        ref={scrollRef}
      />
      <div className="list-title color-black-100">
        <span style={{ fontSize }}>{children}</span>
      </div>
      {showAction && (
        <div className="list-title-action">
          <Link to={linkTo}>View More &gt;</Link>
        </div>
      )}
      {rightContent}
    </div>
  );
}

ListTitle.propTypes = {};

export default ListTitle;
